import React, { useEffect, useRef, createElement, Component } from 'react';
import { MapPinIcon, PhoneIcon, ClockIcon, CarIcon, SendIcon } from 'lucide-react';
const VisitPage = () => {
  const mapRef = useRef(null);
  useEffect(() => {
    // Initialize Leaflet map
    if (mapRef.current) {
      // Check if leaflet is already loaded to avoid duplicate maps
      if (!mapRef.current.hasChildNodes()) {
        // Load Leaflet CSS
        const linkElement = document.createElement('link');
        linkElement.rel = 'stylesheet';
        linkElement.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
        linkElement.integrity = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=';
        linkElement.crossOrigin = '';
        document.head.appendChild(linkElement);
        // Load Leaflet JS
        const script = document.createElement('script');
        script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
        script.integrity = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=';
        script.crossOrigin = '';
        document.head.appendChild(script);
        script.onload = () => {
          // Coordinates for Kilimani, Nairobi
          const lat = -1.2864;
          const lng = 36.7917;
          // Initialize map
          const L = window.L;
          const map = L.map(mapRef.current).setView([lat, lng], 15);
          // Add OpenStreetMap tiles
          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '© OpenStreetMap contributors'
          }).addTo(map);
          // Add marker for Ayira's Cafe
          const marker = L.marker([lat, lng]).addTo(map);
          marker.bindPopup("<b>Ayira's Neuro-Soul Café</b><br>Shiko Road, Kilimani").openPopup();
        };
      }
    }
    return () => {
      // Cleanup if needed
    };
  }, [mapRef]);
  const handleSubmit = e => {
    e.preventDefault();
    // Get form data
    const formData = new FormData(e.target);
    const name = formData.get('name');
    const email = formData.get('email');
    const phone = formData.get('phone');
    const date = formData.get('date');
    const time = formData.get('time');
    const guests = formData.get('guests');
    const message = formData.get('message');
    // Construct mailto URL
    const subject = `Reservation Request from ${name}`;
    const body = `
      Name: ${name}
      Email: ${email}
      Phone: ${phone}
      Date: ${date}
      Time: ${time}
      Number of Guests: ${guests}
      Special Requests: ${message}
    `;
    const mailtoUrl = `mailto:joegoga@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    // Open email client
    window.location.href = mailtoUrl;
  };
  return <div className="min-h-screen w-full bg-[var(--color-paper)]" data-id="element-844">
      {/* Hero Section */}
      <div className="relative h-[40vh] overflow-hidden" data-id="element-845">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2St8j7dtP7wGSk7uTwFS99/ayira_s_neuro_soul_cafe_cover.jpg" alt="Ayira's Cafe exterior view" className="w-full h-full object-cover" data-id="element-846" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent flex items-center" data-id="element-847">
          <div className="container mx-auto px-6" data-id="element-848">
            <h1 className="text-5xl font-medium text-white mb-4" data-id="element-849">Visit Us</h1>
            <div className="w-24 h-1 bg-[var(--color-accent-2)]" data-id="element-850"></div>
          </div>
        </div>
      </div>
      {/* Main Content */}
      <div className="container mx-auto max-w-6xl py-16 px-6" data-id="element-851">
        <div className="fukinsei-grid" data-id="element-852">
          {/* Map Column */}
          <div className="col-span-12 lg:col-span-7 mb-12 lg:mb-0" data-id="element-853">
            <div className="washi-container overflow-hidden" data-id="element-854">
              <div ref={mapRef} className="h-[500px] w-full" data-id="element-855"></div>
            </div>
            <div className="mt-8 washi-container p-8" data-id="element-856">
              <h2 className="text-2xl font-medium mb-6" data-id="element-857">Location Details</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-858">
                <div className="space-y-6" data-id="element-859">
                  <div className="flex items-start" data-id="element-860">
                    <MapPinIcon className="mr-4 mt-1 text-[var(--color-accent-1)] flex-shrink-0" size={22} data-id="element-861" />
                    <div data-id="element-862">
                      <h3 className="font-medium text-lg" data-id="element-863">Address</h3>
                      <p className="font-light" data-id="element-864">
                        Shiko Road, off Elgeyo Marakwet Road, Kilimani, Moi,
                        Nairobi Area, Kenya
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-865">
                    <PhoneIcon className="mr-4 mt-1 text-[var(--color-accent-1)] flex-shrink-0" size={22} data-id="element-866" />
                    <div data-id="element-867">
                      <h3 className="font-medium text-lg" data-id="element-868">Contact</h3>
                      <p className="font-light" data-id="element-869">
                        <a href="tel:+254746210909" className="hover:text-[var(--color-accent-1)] transition duration-300" data-id="element-870">
                          +254 746 210909
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="space-y-6" data-id="element-871">
                  <div className="flex items-start" data-id="element-872">
                    <ClockIcon className="mr-4 mt-1 text-[var(--color-accent-1)] flex-shrink-0" size={22} data-id="element-873" />
                    <div data-id="element-874">
                      <h3 className="font-medium text-lg" data-id="element-875">Opening Hours</h3>
                      <p className="font-light" data-id="element-876">
                        Monday - Friday: 8:00 AM - 8:00 PM
                      </p>
                      <p className="font-light" data-id="element-877">Saturday: 9:00 AM - 9:00 PM</p>
                      <p className="font-light" data-id="element-878">Sunday: 10:00 AM - 6:00 PM</p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-879">
                    <CarIcon className="mr-4 mt-1 text-[var(--color-accent-1)] flex-shrink-0" size={22} data-id="element-880" />
                    <div data-id="element-881">
                      <h3 className="font-medium text-lg" data-id="element-882">Parking</h3>
                      <p className="font-light" data-id="element-883">
                        Ample parking is available on-site. Additional street
                        parking is available nearby.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Reservation Column */}
          <div className="col-span-12 lg:col-span-5" data-id="element-884">
            <div className="washi-container p-8 mb-8 nature-gradient-amber" data-id="element-885">
              <h2 className="text-2xl font-medium mb-6" data-id="element-886">Make a Reservation</h2>
              <p className="font-light mb-6" data-id="element-887">
                We recommend making a reservation to ensure you have the best
                possible experience at Ayira's Cafe.
              </p>
              <a href="tel:+254746210909" className="block w-full btn-ikigai accent-2 text-center mb-8" data-id="element-888">
                Call to Reserve: +254 746 210909
              </a>
              <form className="space-y-4" onSubmit={handleSubmit} data-id="element-889">
                <div data-id="element-890">
                  <label htmlFor="name" className="block text-sm font-medium mb-1" data-id="element-891">
                    Name
                  </label>
                  <input type="text" id="name" name="name" required className="w-full px-4 py-2 border border-[var(--color-subtle)] bg-transparent focus:outline-none focus:ring-1 focus:ring-[var(--color-accent-2)]" placeholder="Your name" data-id="element-892" />
                </div>
                <div data-id="element-893">
                  <label htmlFor="email" className="block text-sm font-medium mb-1" data-id="element-894">
                    Email
                  </label>
                  <input type="email" id="email" name="email" required className="w-full px-4 py-2 border border-[var(--color-subtle)] bg-transparent focus:outline-none focus:ring-1 focus:ring-[var(--color-accent-2)]" placeholder="Your email" data-id="element-895" />
                </div>
                <div data-id="element-896">
                  <label htmlFor="phone" className="block text-sm font-medium mb-1" data-id="element-897">
                    Phone
                  </label>
                  <input type="tel" id="phone" name="phone" required className="w-full px-4 py-2 border border-[var(--color-subtle)] bg-transparent focus:outline-none focus:ring-1 focus:ring-[var(--color-accent-2)]" placeholder="Your phone number" data-id="element-898" />
                </div>
                <div className="grid grid-cols-2 gap-4" data-id="element-899">
                  <div data-id="element-900">
                    <label htmlFor="date" className="block text-sm font-medium mb-1" data-id="element-901">
                      Date
                    </label>
                    <input type="date" id="date" name="date" required className="w-full px-4 py-2 border border-[var(--color-subtle)] bg-transparent focus:outline-none focus:ring-1 focus:ring-[var(--color-accent-2)]" data-id="element-902" />
                  </div>
                  <div data-id="element-903">
                    <label htmlFor="time" className="block text-sm font-medium mb-1" data-id="element-904">
                      Time
                    </label>
                    <input type="time" id="time" name="time" required className="w-full px-4 py-2 border border-[var(--color-subtle)] bg-transparent focus:outline-none focus:ring-1 focus:ring-[var(--color-accent-2)]" data-id="element-905" />
                  </div>
                </div>
                <div data-id="element-906">
                  <label htmlFor="guests" className="block text-sm font-medium mb-1" data-id="element-907">
                    Number of Guests
                  </label>
                  <input type="number" id="guests" name="guests" min="1" required className="w-full px-4 py-2 border border-[var(--color-subtle)] bg-transparent focus:outline-none focus:ring-1 focus:ring-[var(--color-accent-2)]" placeholder="Number of guests" data-id="element-908" />
                </div>
                <div data-id="element-909">
                  <label htmlFor="message" className="block text-sm font-medium mb-1" data-id="element-910">
                    Special Requests
                  </label>
                  <textarea id="message" name="message" rows="4" className="w-full px-4 py-2 border border-[var(--color-subtle)] bg-transparent focus:outline-none focus:ring-1 focus:ring-[var(--color-accent-2)]" placeholder="Any special requests or accommodations needed" data-id="element-911"></textarea>
                </div>
                <button type="submit" className="w-full btn-ikigai accent-1 text-center flex items-center justify-center" data-id="element-912">
                  <SendIcon size={18} className="mr-2" data-id="element-913" />
                  Submit Reservation
                </button>
              </form>
            </div>
            <div className="washi-container p-8 nature-gradient-purple" data-id="element-914">
              <h2 className="text-2xl font-medium mb-6" data-id="element-915">
                Sensory Accommodations
              </h2>
              <p className="font-light mb-6" data-id="element-916">
                At Ayira's Cafe, we strive to create a comfortable environment
                for all our guests. We offer various sensory accommodations to
                ensure your visit is enjoyable.
              </p>
              <div className="space-y-4 wabi-sabi-border" data-id="element-917">
                <div className="flex items-start" data-id="element-918">
                  <div className="w-2 h-2 rounded-full bg-[var(--color-accent-3)] mt-2 mr-3" data-id="element-919"></div>
                  <p className="font-light" data-id="element-920">
                    Quiet zones with reduced noise levels
                  </p>
                </div>
                <div className="flex items-start" data-id="element-921">
                  <div className="w-2 h-2 rounded-full bg-[var(--color-accent-3)] mt-2 mr-3" data-id="element-922"></div>
                  <p className="font-light" data-id="element-923">
                    Adjustable lighting in certain seating areas
                  </p>
                </div>
                <div className="flex items-start" data-id="element-924">
                  <div className="w-2 h-2 rounded-full bg-[var(--color-accent-3)] mt-2 mr-3" data-id="element-925"></div>
                  <p className="font-light" data-id="element-926">Menu items with sensory notes</p>
                </div>
                <div className="flex items-start" data-id="element-927">
                  <div className="w-2 h-2 rounded-full bg-[var(--color-accent-3)] mt-2 mr-3" data-id="element-928"></div>
                  <p className="font-light" data-id="element-929">
                    Trained staff who understand neurodiversity
                  </p>
                </div>
                <div className="flex items-start" data-id="element-930">
                  <div className="w-2 h-2 rounded-full bg-[var(--color-accent-3)] mt-2 mr-3" data-id="element-931"></div>
                  <p className="font-light" data-id="element-932">
                    Sensory kits available upon request
                  </p>
                </div>
              </div>
              <p className="mt-6 font-light" data-id="element-933">
                Please let us know of any specific accommodations you need when
                making your reservation.
              </p>
            </div>
          </div>
        </div>
        {/* African-inspired decorative element */}
        <div className="mt-16 flex justify-center" data-id="element-934">
          <div className="flex space-x-3" data-id="element-935">
            <div className="w-2 h-2 rounded-full bg-[var(--color-accent-1)]" data-id="element-936"></div>
            <div className="w-8 h-2 rounded-full bg-[var(--color-accent-2)]" data-id="element-937"></div>
            <div className="w-2 h-2 rounded-full bg-[var(--color-accent-3)]" data-id="element-938"></div>
          </div>
        </div>
      </div>
    </div>;
};
export default VisitPage;